import React from "react";
import { format } from "date-fns";
import { DATE_FNS_SHORT_DATE_FORMAT } from "shared/constants";
import { WithTooltip } from "shared/table-helpers";
import { Checkbox } from "components/form-inputs/plain-inputs";

export const buildColumns = (updateSelectedUpc, setAllUpcs, keyList) => {
    return [
        {
            Header: (props) => {
                const hasNoData = props.data.length === 0;
                const value = hasNoData ? !hasNoData : keyList.length === props.data.length;

                return (
                    <Checkbox
                        name="selected-state"
                        value={value}
                        onChange={() => setAllUpcs(value ? [] : props.data)}
                    />
                );
            },
            accessor: "key",
            filterable: false,
            sortable: false,
            Cell: (row) => {
                return (
                    <Checkbox
                        name={`select_${row.value}`}
                        value={keyList.includes(row.value)}
                        onChange={(e) => {
                            updateSelectedUpc(row.original, e.currentTarget.value);
                        }}
                    />
                );
            },
            width: 65,
            className: "txt-center",
        },

        {
            Header: "Upc",
            filterable: false,
            accessor: "upc",
            Cell: (row) => {
                return row.original.productModifier ? `${row.original.upc}-${row.original.productModifier}` : row.original.upc;
            },
        },
        {
            Header: "Bin #",
            accessor: "binTrackingNumber",
            filterable: false,
        },
        {
            Header: "CES Client",
            accessor: "cxHClient",
            filterable: false,
        },
        {
            Header: "GDN Client",
            accessor: "gdnClient",
            filterable: false,
        },
        {
            Header: "Finalized",
            accessor: "publishDate",
            filterable: false,
            maxWidth: 132,
            Cell: (row) => {
                const dateString = row.value ? format(new Date(row.value), DATE_FNS_SHORT_DATE_FORMAT) : "";

                return WithTooltip(dateString);
            },
        },
        {
            Header: "Key",
            accessor: "key",
            filterable: false,
        },
        {
            Header: "Correlation ID",
            accessor: "correlationId",
            sortable: false,
            filterable: false,
        },
        {
            Header: "Send to GDSN",
            accessor: "sendToGdsn",
            filterable: false,
            Cell: (row) => {
                return (
                    <Checkbox
                        name={`select_${row.value}`}
                        value={row.value}
                        disabled
                    />
                );
            },
        },
    ];
};
